import React, { useState } from 'react';
import './PersonSelector.scss';
import Dropdown from 'react-bootstrap/esm/Dropdown';
import { Avatar } from '../../features/avatar/Avatar';
import { DossierMember } from '../../models/DossierMember';
import classNames from 'classnames';

export interface IPersonSelectorProps {
  persons: DossierMember[];
  selected: DossierMember[];
  onClickItem: (persons: DossierMember) => void;
  keepDropdownOpenOnItemClick?: boolean;
}

function PersonSelector({ persons, selected, onClickItem, keepDropdownOpenOnItemClick }: IPersonSelectorProps): JSX.Element {
  const [isOpen, setIsopen] = useState<boolean>(false);
  const handleItemClick = (person: DossierMember) => {
    onClickItem(person);
    if (!keepDropdownOpenOnItemClick) {
      setIsopen(!isOpen);
    }
  };

  return <Dropdown show={isOpen}>
    <Dropdown.Toggle as="button" className="person-selector__toggle" aria-label="Selecteer een deelnemer" onClick={() => setIsopen(!isOpen)}>
      { selected.length === 0 && 'Selecteer een deelnemer' }
      {
        selected.length > 0 && <>
          <div className="person-selector__toggle-avatar-list">{ selected.map(person => <Avatar key={person.memberId} user={person.user} />) }</div>
          <div className="person-selector__toggle-names-list">{ selected.length === 1 ? selected[0].user.name : `${selected.length} deelnemers` }</div>
        </>
      }
    </Dropdown.Toggle>

    <Dropdown.Menu as="div" className="person-selector__menu">
      { persons.map(person => {
        const isSelected = selected.includes(person);
        return <Dropdown.Item className="person-selector__person" as="button" key={person.memberId} aria-selected={isSelected} active={isSelected} onClick={() => handleItemClick(person)}>
          <Avatar className={classNames('person-selector__person-avatar', { 'person-selector__person-avatar--selected': isSelected })} user={person.user} />
          <div className="person-selector__person-info">
            <div className="person-selector__person-name">{person.user.name}</div>
            <div className="person-selector__person-role">{person.getRoleText({ capitalize: true })}</div>
          </div>
        </Dropdown.Item>;
      }) }
    </Dropdown.Menu>
  </Dropdown>;
}

export default PersonSelector;
